var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { eventBus } from './liveHearings.entry';
var LiveHearingViewer = /** @class */ (function (_super) {
    __extends(LiveHearingViewer, _super);
    function LiveHearingViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.videoUrl = function (hearing) {
            var webroot = window.application.webroot || '/';
            var archiveoffset = hearing.archiveoffset, archive_stream_name = hearing.archive_stream_name;
            return 'https://www.senate.gov/isvp/?auto_play=false&comm=' + _this.props.config.streamPrefix + (archiveoffset ? '&stt=' + archiveoffset : '') + '&poster=' + webroot + 'assets/images/video-poster.png' + '&filename=' + archive_stream_name;
        };
        _this.state = {
            nextHearing: null,
            liveHearing: null,
        };
        return _this;
    }
    LiveHearingViewer.prototype.componentDidMount = function () {
        var _this = this;
        var _a;
        var initialState;
        if ((_a = window.liveHearings) === null || _a === void 0 ? void 0 : _a.getState)
            initialState = window.liveHearings.getState();
        if (initialState)
            this.setState(initialState);
        eventBus.on('hearingUpdate', function (data) {
            if (data.state) {
                _this.setState(data.state);
            }
        });
    };
    LiveHearingViewer.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (prevState.liveHearing !== this.state.liveHearing && this.state.liveHearing !== null) {
            if (this.props.videoContainer)
                this.props.videoContainer.classList.add('is-ready');
        }
    };
    LiveHearingViewer.prototype.render = function () {
        return (React.createElement("div", { className: 'LiveHearingViewer' }, this.state.liveHearing && (React.createElement("iframe", { src: this.videoUrl(this.state.liveHearing), width: "570", height: "320", allowFullScreen: true }))));
    };
    return LiveHearingViewer;
}(Component));
window.setupLiveHearingViewer = function (options) {
    ReactDOM.render(React.createElement(LiveHearingViewer, { config: options.config, videoContainer: options.videoContainer }), options.videoContainer);
};
